window.Vivus = require('vivus');
require('velocity-animate');

$(function() {

  $(window).scroll(function() {
    $('.anim-trigger').each(function() {
      var _trigger = $(this);
      onScrollPast( _trigger, function() {
        handleAnimations(_trigger);
      });
    })
  })

  var animations = [
    {
      className : 'shrink-in',
      animationFrom : {'scaleX': 2, 'scaleY' : 2, 'opacity' : 0},
      animationTo : {'scaleX': 1, 'scaleY' : 1, 'opacity' : 1},
    },
    {
      className : 'grow-in',
      animationFrom : {'scaleX': 0, 'scaleY' : 0, 'opacity' : 0},
      animationTo : {'scaleX': 1, 'scaleY' : 1, 'opacity' : 1},
    },
    {
      className : 'fade-up',
      animationFrom : {'translateY': '100px', 'opacity' : 0},
      animationTo : {'translateY': '0px', 'opacity' : 1},
    },
    {
      className : 'fade-in',
      animationFrom : {'opacity' : 0},
      animationTo : {'opacity' : 1},
    },
    {
      className : 'fade-left',
      animationFrom : {'translateX': '100px', 'opacity' : 0},
      animationTo : {'translateX': '0px', 'opacity' : 1},
    },
    {
      className : 'fade-right',
      animationFrom : {'translateX': '-100px', 'opacity' : 0},
      animationTo : {'translateX': '0px', 'opacity' : 1},
    },
  ];

  function handleAnimations(trigger) {
    for (var i = 0; i < animations.length; i++) {
      trigger.find('.' + animations[i]['className']).each(function() {
        $(this).velocity(animations[i]['animationFrom'], 0)
          .velocity(
            animations[i]['animationTo'], {
              duration: 1000,
              delay: $(this)[0].hasAttribute('anim-delay') ? $(this).attr('anim-delay') : 0,
              easing: 'easeInOutSine',
            }
          );
      })
    }
  }

  function onScrollPast(scrollObject, scrollFunction) {
    var top_of_object = scrollObject.offset().top;
    var bottom_of_window = $(window).scrollTop() + $(window).height();

    if(top_of_object < bottom_of_window && scrollObject.attr('anim-passed') != 1) {
      scrollObject.attr('anim-passed', 1);
      scrollFunction();
    }/*   else if(top_of_object - 200 >= bottom_of_window && scrollObject.attr('anim-passed') == 1) {
            scrollObject.attr('css', '');
            scrollObject.attr('anim-passed', 0);
        }  */
  }

})


$(document).ready(function () {

  $('.main-logo-svg').velocity({'opacity': 1}, 1000);
  new window.Vivus('logo-text', {duration: 700});
  setTimeout(function () {
    $('.main-logo').velocity({'opacity': 1}, 800);
    $('.main-logo-svg').velocity({'opacity': 0}, 800);
  }, 1000)


  function allParallax() {
    if (window.innerWidth <= 767)
      return;
    parallax($('.food-a'));
    parallax($('.food-b'));
    parallaxTransform($('.overlay'));
    parallaxTransform($('.overlay2'));
    $('.banner-a .container').css('transform', 'translateY(' + ($(window).scrollTop() / 5) + 'px)')
  }

  allParallax();


  $(window).scroll(function () {
    allParallax();
  })


  function parallax(scrollObject) {
    var top_of_object = scrollObject.offset().top;
    var bottom_of_window = $(window).scrollTop() + $(window).height();

    scrollObject.css({'backgroundPositionY': (top_of_object - bottom_of_window) / 5 + 'px'});
  }

  function parallaxTransform(scrollObject) {
    var top_of_object = scrollObject.offset().top;
    var bottom_of_window = $(window).scrollTop() + $(window).height();

    scrollObject.velocity({'translateY': ((bottom_of_window - top_of_object) / 5) - 200 + 'px'}, {
      easing: [1],
      duration: 0,
    });
  }


});

$(function () {
  if (!isMac()) {
    $('html').easeScroll({
      frameRate: 60,
      animationTime: 1000,
      stepSize: 60,
      pulseAlgorithm: 1,
      pulseScale: 8,
      pulseNormalize: 1,
      accelerationDelta: 40,
      accelerationMax: 1,
      keyboardSupport: true,
      arrowScroll: 50,
      touchpadSupport: true,
      fixedBackground: true,
    });
  }
});

function isMac() {
  return navigator.userAgent.indexOf('Mac OS X') > -1;
}



// WEBPACK FOOTER //
// ./scripts/main.js